import React from 'react';

interface OwnProps {
  publishableKey: string;
  sessionId: string;
}

type Props = Readonly<OwnProps>;

const StripeCheckout: React.FC<Props> = ({ publishableKey, sessionId }) => {
  React.useEffect(() => {
    const stripe = Stripe(publishableKey);

    stripe.redirectToCheckout({
      sessionId,
    });
  }, []);

  return null;
};

export default React.memo(StripeCheckout);
